import React from 'react';
import '../styles/home.css';
import { Link } from 'react-router-dom';

const Work = () => {
    return (
        <div id='work-container'>


            <div className='work-card card'>
                <div className='work-card-description1'>
                    <h3>FlashRoom</h3>
                    <div className='quick-flex'>
                        <h4>Tech Used:</h4>
                        <div className='tech-used'>
                            <img src='images/reacticon.png' />
                            <img src='images/typescripticon.png' />
                            <img src='images/sassicon.png' />
                            <img src='images/nodeicon.png' />
                            <img src='images/mongodbicon.png' />
                            <img src='images/awsicon.png' />




                        </div>
                    </div>

                </div>
                <div className='work-img-cont'>
                    <img src='images/flashroom.png' />
                </div>
                <div className='work-card-description1'>
                    <p>Instant file sharing and collaboration app.</p>

                    <Link to='/flashroom'>
                        <button className='work-btn'>Learn More</button>
                    </Link>

                </div>
            </div>

            <div className='work-card card'>
                <div className='work-card-description1'>
                    <h3>Alpha Builders</h3>
                    <div className='quick-flex'>
                        <h4>Tech Used:</h4>
                        <div className='tech-used'>
                            <img src='images/reacticon.png' />
                            <img src='images/nodeicon.png' />
                            <img src='images/gcpicon.png' />
                            <img src='images/cssicon.png' />
                            <img src='images/mongodbicon.png' />
                        </div>
                    </div>

                </div>
                <div className='work-img-cont'>
                    <img src='project-images/ab.jpg' />
                </div>
                <div className='work-card-description1'>
                    <p>React site with Node.js backend and CMS. Images upload to Google Cloud bucket.</p>
                    <Link to="/alphabuilders">
                        <button className='work-btn'>Learn More</button>
                    </Link>

                </div>
            </div>

            <div className='work-card card'>
                <div className='work-card-description1'>
                    <h3>Between Choirs</h3>
                    <div className='quick-flex'>
                        <h4>Tech Used:</h4>
                        <div className='tech-used'>
                            <img src='images/reacticon.png' />
                            <img src='images/cssicon.png' />
                            <img src='images/aiicon.png' />
                            <img src='images/apicon.png' />


                        </div>
                    </div>

                </div>

                <div className='work-img-cont'>
                    <img src='project-images/between-choirs.jpg' />
                </div>
                <div className='work-card-description1'>
                    <p>Entertainment app with games and articles.
                        Built in React for Scholarship Auditions.</p>
                    <Link to="/betweenchoirs">
                        <button className='work-btn'>Learn More</button>
                    </Link>

                </div>
            </div>









            <div className='work-card card'>
                <div className='work-card-description1'>
                    <h3>Therapist Website</h3>
                    <div className='quick-flex'>
                        <h4>Tech Used:</h4>
                        <div className='tech-used'>
                            <img src='images/wpicon.png' />
                            <img src='images/htmlicon.png' />
                            <img src='images/cssicon.png' />
                            <img src='images/aiicon.png' />
                            <img src='images/apicon.png' />


                        </div>
                    </div>

                </div>
                <div className='work-img-cont'>
                    <img src='project-images/poh.jpg' />
                </div>
                <div className='work-card-description1'>
                    <p>Company site for Peace of Heart Therapy.
                        Designed site, logo, and print materials.</p>
                    <Link to='/therapistwebsite'>
                        <button className='work-btn'>Learn More</button>
                    </Link>

                </div>
            </div>



            <div className='work-card card'>
                <div className='work-card-description1'>
                    <h3>Eventure</h3>
                    <div className='quick-flex'>
                        <h4>Tech Used:</h4>
                        <div className='tech-used'>
                            <img src='images/aiicon.png' />
                            <img src='images/apicon.png' />
                            <img className='figma-icon' src='images/figmaicon.png' />


                        </div>
                    </div>

                </div>
                <div className='work-img-cont'>
                    <img src='project-images/eventure.jpg' />

                </div>
                <div className='work-card-description1'>
                    <p>UI design for a concept ticketing app. I have started developing it but its still in progress</p>
                    <Link to='/eventure'>
                        <button className='work-btn'>Learn More</button>
                    </Link>

                </div>
            </div>



            <div className='work-card card'>
                <div className='work-card-description1'>
                    <h3>Drink Campaign</h3>
                    <div className='quick-flex'>
                        <h4>Tech Used:</h4>
                        <div className='tech-used'>
                            <img src='images/aiicon.png' />
                            <img src='images/apicon.png' />
                            <img src='images/indesignicon.png' />


                        </div>
                    </div>

                </div>
                <div className='work-img-cont'>
                    <img src='project-images/poster.jpg' />

                </div>
                <div className='work-card-description1'>
                    <p>Drink campaign with full brand suite.
                        Illustrated cans, posters, t shirts, and other merch.</p>
                    <Link to='/drinkcampaign'>
                        <button className='work-btn'>Learn More</button>
                    </Link>

                </div>
            </div>


            {/* 
            <div className='work-card card'>
                <div className='work-card-description1'>
                    <h3>Portfolio</h3>
                    <div className='quick-flex'>
                        <h4>Tech Used:</h4>
                        <div className='tech-used'>
                            <img src='images/aiicon.png' />
                            <img src='images/apicon.png' />
                            <img src='images/indesignicon.png' />
                        </div>
                    </div>

                </div>
                <div className='work-img-cont'>
                    <img src='project-images/ellie-portfolio.jpg' />

                </div>
                <div className='work-card-description1'>
                    <p>Drink campaign with full brand suite.
                        Illustrated cans, posters, t shirts, and other merch.</p>
                    <Link to='/drinkcampaign'>
                        <button className='work-btn'>Learn More</button>
                    </Link>

                </div>
            </div> */}


        </div>
    )
}

export default Work